export const frontmatter = {
    "draft": true,
    "title": "API and Webhooks",
    "sidebar_group": "reference",
    "sidebar_label": "API and Webhooks",
    "sidebar_order": 1
}

export const toc = []